import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import VerifyInsurance from '@/components/verify-insurance';

export default function VerifyInsuranceScreen() {
  const { styles } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <VerifyInsurance />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    backgroundColor: theme.colors.background_1,
  },
}));
